(function () {
  'use strict';

  var CONFIGS = window.RVProductPromo;
  if (!CONFIGS || !CONFIGS.length) return;

  var INTERNAL_HEADER = 'X-RV-Product-Promo';
  var MIN_SYNC_INTERVAL_MS = 4000;

  function formatDuration(ms) {
    if (ms < 0) ms = 0;
    var totalSeconds = Math.floor(ms / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var prefix = '';
    if (days > 0) {
      prefix = days + ' ' + (days === 1 ? 'Tag' : 'Tage') + ' ';
    }
    return prefix + pad(hours) + ' Std. ' + pad(minutes) + ' Min. und ' + pad(seconds) + ' Sek.';
  }

  function fetchJSON(url, options) {
    options = options || {};
    options.headers = options.headers || {};
    options.headers[INTERNAL_HEADER] = '1';
    return fetch(url, options).then(function (response) {
      if (!response.ok) {
        return response.text().then(function (bodyText) {
          var err = new Error('Request to ' + url + ' failed with ' + response.status);
          err.status = response.status;
          err.body = bodyText;
          throw err;
        });
      }
      return response.json();
    });
  }

  function getCart() {
    return fetchJSON('/cart.js', { headers: {} });
  }

  // Mirrors the section-refresh conventions already used by cart-drawer.js / cart.js
  // and assets/free-gift-promo.js in this theme, so a newly added gift line item
  // appears instantly in the cart drawer / cart page without a full reload.
  function collectSectionTargets() {
    var targets = [];
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      cartDrawer.getSectionsToRender().forEach(function (s) {
        var selector = s.selector || '.shopify-section';
        var target = s.selector ? document.querySelector(selector) : document.getElementById(s.id);
        if (target) targets.push({ sectionName: s.id, target: target, selector: selector });
      });
    }
    var mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems && mainCartItems.dataset.id) {
      var itemsTarget = mainCartItems.querySelector('.js-contents') || mainCartItems;
      targets.push({ sectionName: mainCartItems.dataset.id, target: itemsTarget, selector: '.js-contents' });
    }
    var mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter && mainCartFooter.dataset.id) {
      var footerTarget = mainCartFooter.querySelector('.js-contents') || mainCartFooter;
      targets.push({ sectionName: mainCartFooter.dataset.id, target: footerTarget, selector: '.js-contents' });
    }
    return targets;
  }

  function sectionNames(targets) {
    var names = targets.map(function (t) { return t.sectionName; });
    return names.filter(function (v, i, a) { return v && a.indexOf(v) === i; });
  }

  function applySections(sectionsHtml, targets) {
    if (!sectionsHtml) return;
    targets.forEach(function (t) {
      var html = sectionsHtml[t.sectionName];
      if (!html || !t.target) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(t.selector);
      if (parsed) t.target.innerHTML = parsed.innerHTML;
    });
  }

  function createPromoState(cfg) {
    var banner = document.getElementById(cfg.bannerId);
    return {
      cfg: cfg,
      end: new Date(cfg.endsAt).getTime(),
      banner: banner,
      timerEl: banner ? banner.querySelector('[data-product-promo-timer]') : null,
      countdownIntervalId: null,
      syncing: false,
      syncQueued: false,
      lastSyncAt: 0,
      backoffUntil: 0,
      consecutiveFailures: 0,
      lastGiftPresent: false
    };
  }

  function isPromoActive(state, now) {
    return now < state.end;
  }

  function showBanner(state) {
    if (state.banner) state.banner.hidden = false;
  }

  function hideBanner(state) {
    if (state.banner) state.banner.hidden = true;
    if (state.countdownIntervalId) {
      clearInterval(state.countdownIntervalId);
      state.countdownIntervalId = null;
    }
  }

  function tickCountdown(state) {
    var now = Date.now();
    if (!isPromoActive(state, now)) {
      hideBanner(state);
      return;
    }
    if (state.timerEl) state.timerEl.textContent = formatDuration(state.end - now);
    showBanner(state);
  }

  function startCountdown(state) {
    if (state.countdownIntervalId) return;
    tickCountdown(state);
    state.countdownIntervalId = setInterval(function () {
      tickCountdown(state);
    }, 1000);
  }

  function isGiftLine(state, item) {
    return (
      item.variant_id === state.cfg.giftVariantId &&
      item.properties &&
      item.properties[state.cfg.propertyKey] === state.cfg.propertyValue
    );
  }

  function findGiftLine(state, cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (isGiftLine(state, cart.items[i])) return cart.items[i];
    }
    return null;
  }

  function mainProductQuantity(state, cart) {
    var sum = 0;
    var ids = state.cfg.mainVariantIds;
    for (var i = 0; i < cart.items.length; i++) {
      if (ids.indexOf(cart.items[i].variant_id) !== -1) sum += cart.items[i].quantity;
    }
    return sum;
  }

  function addGift(state, targets) {
    var properties = {};
    properties[state.cfg.propertyKey] = state.cfg.propertyValue;
    return fetchJSON(state.cfg.addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: state.cfg.giftVariantId, quantity: 1, properties: properties }],
        sections: sectionNames(targets),
        sections_url: window.location.pathname
      })
    });
  }

  function removeGiftLine(state, line, targets) {
    return fetchJSON(state.cfg.changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: line.key,
        quantity: 0,
        sections: sectionNames(targets),
        sections_url: window.location.pathname
      })
    });
  }

  function sync(state, force) {
    var now = Date.now();

    if (!force && now < state.backoffUntil) return;
    if (!force && now - state.lastSyncAt < MIN_SYNC_INTERVAL_MS) return;

    if (state.syncing) {
      state.syncQueued = true;
      return;
    }

    state.lastSyncAt = now;
    state.syncing = true;

    getCart()
      .then(function (cart) {
        var nowInner = Date.now();
        var active = isPromoActive(state, nowInner);
        var giftLine = findGiftLine(state, cart);
        var mainQty = mainProductQuantity(state, cart);

        state.lastGiftPresent = !!giftLine;

        var targets = collectSectionTargets();

        if (active && !giftLine && mainQty > 0) {
          return addGift(state, targets).then(function (response) {
            state.consecutiveFailures = 0;
            state.lastGiftPresent = true;
            applySections(response.sections, targets);
          });
        }

        if (giftLine && (!active || mainQty === 0)) {
          return removeGiftLine(state, giftLine, targets).then(function (response) {
            state.consecutiveFailures = 0;
            state.lastGiftPresent = false;
            applySections(response.sections, targets);
          });
        }

        state.consecutiveFailures = 0;
      })
      .catch(function (err) {
        // Back off after a failure so a persistent error (e.g. sold out gift,
        // temporary API issue) can never turn into a rapid retry storm.
        state.consecutiveFailures += 1;
        var backoffMs = Math.min(15000 * Math.pow(2, state.consecutiveFailures - 1), 300000);
        state.backoffUntil = Date.now() + backoffMs;
        if (window.console && console.warn) {
          console.warn(
            '[product-promo] sync failed for product ' + state.cfg.productId + ', backing off ' +
              Math.round(backoffMs / 1000) + 's',
            err
          );
        }
      })
      .then(function () {
        state.syncing = false;
        if (state.syncQueued) {
          state.syncQueued = false;
          scheduleSync(state, 0);
        }
      });
  }

  function scheduleSync(state, delay, force) {
    setTimeout(function () {
      sync(state, force);
    }, delay || 0);
  }

  var states = CONFIGS.map(createPromoState);

  // Hook into cart mutations triggered anywhere else on the page (product forms,
  // quantity steppers, the cart drawer, other promo scripts, etc.) so the gift
  // stays in sync without editing those files. Requests made by this script
  // itself carry an internal header and are skipped, so our own add/remove
  // calls can never re-trigger themselves in a loop. If window.fetch was
  // already patched by another script on this page (e.g. free-gift-promo.js
  // or bundle-builder.js), we wrap that patched version rather than replacing
  // it, so every script's sync logic keeps working together.
  if (!window.__productPromoFetchPatched) {
    window.__productPromoFetchPatched = true;
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isInternal = !!(init && init.headers && init.headers[INTERNAL_HEADER]);
      var isCartMutation = !isInternal && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
      var result = originalFetch.apply(this, arguments);
      if (isCartMutation) {
        result
          .then(function () {
            states.forEach(function (state) {
              scheduleSync(state, 250);
            });
          })
          .catch(function () {});
      }
      return result;
    };
  }

  function init() {
    states.forEach(function (state) {
      if (isPromoActive(state, Date.now())) startCountdown(state);
      scheduleSync(state, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Fallback periodic check in case a cart mutation happens outside of fetch()
  // (e.g. a full form submit / redirect flow bypassing the fetch hook above).
  // sync() itself enforces MIN_SYNC_INTERVAL_MS / backoff, so this can never
  // cause a rapid burst of requests.
  setInterval(function () {
    states.forEach(function (state) {
      if (isPromoActive(state, Date.now())) scheduleSync(state, 0);
    });
  }, 30000);
})();
